var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBlock = function SvgBlock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 113,
    height: 113,
    viewBox: "0 0 113 113"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "block",
    transform: "translate(1.5 1.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "do-not-disturb"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M55,0a55,55,0,1,0,55,55A55.162,55.162,0,0,0,55,0ZM11,55A44.129,44.129,0,0,1,55,11a43.345,43.345,0,0,1,26.95,9.35l-61.6,61.6A43.345,43.345,0,0,1,11,55ZM55,99a43.345,43.345,0,0,1-26.95-9.35l61.6-61.6A43.345,43.345,0,0,1,99,55,44.129,44.129,0,0,1,55,99Z",
    fill: "#74757d",
    stroke: "#fff",
    strokeWidth: 3
  })))));
};
export default SvgBlock;